import React from 'react';
import PropTypes from 'prop-types';
import InvoiceTextField from '../../InvoiceTextField';
import SovosDatePicker from 's1-ui/sovos-datepicker/SovosDatePicker';
import { basicInfoFieldsRows, uneditableFields } from '../InvoiceFieldsHelper';
import './InvoiceBasicInfoSection.scss';

const flexInputsColumnStyle = { flex: 1, marginLeft: 24, marginBottom: 10 };
const flexFirstColumnStyle = { flex: 1, marginBottom: 10 };
const emptyErrorMessage = '';

const InvoiceBasicInfoSection = props => (
  <React.Fragment>
    <h1 className="invoice-line-section-title">Basic information</h1>
    {
      basicInfoFieldsRows.map((row, rowIndex) => (
        <div key={ rowIndex } style={ { display: 'flex' } }>
          {
            row.map((field, fieldIndex) => (
              field.dataType === 'date' ? 
                <SovosDatePicker
                  name={ field.key }
                  onChange={ (ev, value) => props.onFieldChange(field.key, value, emptyErrorMessage) }
                  value={ props.basicInfoData[field.key] }
                  format="YYYY-MM-DD"
                  label={ field.label }
                  className="date-picker"
                  style={ { marginTop: 13, width: 100, marginLeft: 24 } }
                /> :
                <InvoiceTextField
                  key={ field.key }
                  name={ field.key }
                  label={ field.label }
                  value={ props.basicInfoData[field.key] }
                  onChange={ (ev, value, errorMessage) => props.onFieldChange(ev, value, errorMessage) }
                  fullWidth={ true }
                  style={
                    fieldIndex === 0
                      ? flexFirstColumnStyle
                      : flexInputsColumnStyle
                  }
                  disabled={
                    uneditableFields.some(uneditableField => uneditableField === field.key)
                  }
                  dataType={ field.dataType }
                  stringMaxLength={ field.stringMaxLength || '' }
                />
            ))
          }
        </div>
      ))
    }
  </React.Fragment>
);

InvoiceBasicInfoSection.propTypes = {
  basicInfoData: PropTypes.object.isRequired,
  onFieldChange: PropTypes.func.isRequired
};

export default InvoiceBasicInfoSection;



// WEBPACK FOOTER //
// ./src/components/viewTransactions/viewTransactionsGrid/c/invoiceLinesSlidingPanel/invoiceEditor/invoiceEditorSections/InvoiceBasicInfoSection.js